export const activityModule = { contact: "1", campaign: "2", special: "3" };

export const contactActivity = {
  1: {
    uid: 1,
    icon: "trigger-contact-1",
    iconWidth: "42",
    title: "Contact joins to a particular list",
    description: `Set up email automation that will trigger when a new contact gets added to the email list.`,
    shortDesc: `The trigger will start when any contact is added to selected list`,
    type: activityModule["contact"],
    isPopular: true,
  },
  2: {
    uid: 2,
    icon: "trigger-contact-1",
    iconWidth: "42",
    title: "Contact joins to audience",
    description: `Shoot automated targeted emails to contacts who will join the audience.`,
    shortDesc: ``,
    type: activityModule["contact"],
    isPopular: true,
  },
  3: {
    uid: 3,
    icon: "trigger-contact-2",
    iconWidth: "42",
    title: "Contact added through webform",
    description: `Set up email automation to trigger emails whenever a contact submits a Mailercloud webform.`,
    shortDesc: `The trigger will start when any contact is added through Webform`,
    type: activityModule["contact"],
  },
  4: {
    uid: 4,
    icon: "trigger-contact-3",
    iconWidth: "42",
    title: "Contact added through API",
    description: `Set up email automation workflow to trigger emails when a contact is added through API.`,
    shortDesc: `The trigger will start when any contact is added to selected API`,
    type: activityModule["contact"],
  },
  5: {
    uid: 5,
    icon: "trigger-contact-4",
    iconWidth: "42",
    title: "Any list’s contacts property value changes",
    description: `Triggers automated targeted emails when any list’s contact property value changes.`,
    shortDesc: `Select property and enter the new value to update the contact property.`,
    type: activityModule["contact"],
    isPopular: true,
  },
  6: {
    uid: 6,
    icon: "trigger-contact-4-2",
    iconWidth: "42",
    title: "Specific list’s contact property values changes",
    description: `Shoot automated emails immediately when a property value of a contact of a specific list changes.`,
    shortDesc: `Select property and enter the new value to update the contact property.`,
    type: activityModule["contact"],
  },
  14: {
    uid: 14,
    icon: "contact-tag",
    iconWidth: "42",
    title: "Contact tag added",
    description: `When a specific tag is added to your mailing list, you can use a trigger to start an email automation sequence`,
    shortDesc: `Trigger is used to start an email automation sequence when a specific tag is added to a contact in your mailing list.`,
    type: activityModule["contact"],
    isPopular: true,
  },
};

export const campaignActivity = {
  7: {
    uid: 7,
    icon: "trigger-campaign-1",
    iconWidth: "42",
    title: "Opened email",
    description: `Set up automation workflow to trigger emails when a contact opens an email.`,
    shortDesc: `The trigger will start when open this email`,
    type: activityModule["campaign"],
    isPopular: true,
  },
  8: {
    uid: 8,
    icon: "trigger-campaign-2",
    iconWidth: "42",
    title: "Not opened email",
    description: `Set up automation workflow to send follow-up emails to those contacts who haven’t opened the last email of the campaign.`,
    shortDesc: `The trigger will start when not open this email`,
    type: activityModule["campaign"],
    isPopular: true,
  },
  9: {
    uid: 9,
    icon: "trigger-campaign-3",
    iconWidth: "42",
    title: "Clicked emails",
    description: `Trigger relevant emails through automation workflows to those contacts who have clicked the email.`,
    shortDesc: `The trigger will start when clicked email`,
    type: activityModule["campaign"],
    isPopular: true,
  },
  10: {
    uid: 10,
    icon: "trigger-campaign-4",
    iconWidth: "42",
    title: "Not clicked email",
    description: `Incentivise the contacts through targeted email automation workflows who have not clicked the emails.`,
    shortDesc: `The trigger will start when not clicked email after a wait time`,
    type: activityModule["campaign"],
  },
  // 9: {
  //   uid: 9,
  //   icon: "trigger-campaign-5",
  //   iconWidth: "42",
  //   title: "Clicks any email link",
  //   description: `Dummy text: Its function as a filler or as a tool for comparing the visual impression`,
  //   shortDesc: "Clicks any email link",
  //   type: activityModule["campaign"],
  //   isPopular: true,
  // },
  // 10: {
  //   uid: 10,
  //   icon: "trigger-campaign-6",
  //   iconWidth: "42",
  //   title: "Clicks specific link in a email",
  //   description: `Dummy text: Its function as a filler or as a tool for comparing the visual impression`,
  //   shortDesc: "Clicks specific link in a email",
  //   type: activityModule["campaign"],
  // },
  11: {
    uid: 11,
    icon: "trigger-campaign-7",
    iconWidth: "42",
    title: "Sent an email",
    description: `Shoot targeted automated emails to contacts who have sent an email and keep them engaged in the marketing funnel.`,
    shortDesc: `The trigger will start when email are sent`,
    type: activityModule["campaign"],
  },
  /*{
    uid: 12,
    icon: "trigger-campaign-8",
    iconWidth: "42",
    title: "Doesn't click email link",
    description: `Dummy text: Its function as a filler or as a tool for comparing the visual impression`,
    shortDesc: 'Doesn't click email link',
    type: activityModule["campaign"],
  },*/
};

export const specialActivity = {
  // 12: {
  //   uid: 12,
  //   icon: "trigger-special-1",
  //   iconWidth: "42",
  //   title: "Special events",
  //   description: `Set up email automation workflow to trigger before or after specific dates, that you can select from the date property field.`,
  //   shortDesc: `The trigger will start any special date you choosed`,
  //   type: activityModule["special"],
  //   isPopular: true,
  // },
};

export const allActivity = {
  ...contactActivity,
  ...campaignActivity,
  ...specialActivity,
};

export const propertyConditionMaping = {
  Text: [5, 6, 7, 8, 11, 12],
  Number: [5, 6, 7, 8, 11, 12, 13, 15],
  Date: [5, 6, 11, 12],
};
export const filterChangeCondition = {
  1: "Contains",
  2: "Not contains",
  3: "Start with",
  4: "End with",
  5: "Is equal to",
  6: "Is not equal to",
  7: "Is equalto any of",
  8: "Is not equalto any of",
  9: "contains all of",
  10: "doesn't contains all of",
  11: "Is empty",
  12: "Is not empty",
  13: "Is greater than",
  14: "Is more than",
  15: "Is less than",
  16: "Between",
  17: "Not between",
  18: "Is before",
  19: "Is after",
  20: "Is before another date property",
  21: "Is after another date property",
  23: "Any time",
  24: "Between 2 dates",
  25: "In last days",
  26: "Not in last days",
  27: "Count",
  28: "Is",
  29: "Is not",
};
export const filterChangeSubCondition = {
  1: "Active",
  2: "Unknown",
  3: "Valid",
  4: "Opened",
  5: "Clicked",
};

export const flterConditions = [
  { id: 8, label: "Campaign activity" },
  { id: 2, label: "Subscriber status" },
  { id: 1, label: "Contact property" },
  { id: 10, label: "Contact details" },
  { id: 3, label: "Contact rating" },
  { id: 4, label: "Domain" },
  { id: 5, label: "Subscriber opened" },
  { id: 6, label: "Global openers" },
  { id: 7, label: "Campaign tag" },
  { id: 9, label: "Contact tag" },
];

export const getContactDetailsFilters = () => [
  {
    label: "Created date",
    value: "created_date",
    type: "Date",
    map: "created_date",
  },
  {
    label: "Modified date",
    value: "modified_date",
    type: "Date",
    map: "modified_date",
  },
];

export const filterConditionMaping = {
  2: [28, 29],
  3: [5, 16],
  4: [5, 6, 11, 12],
  5: [27, 25, 26],
  6: [5, 6, 15, 13, 16],
  8: [23, 24, 25],
  9: [23, 24, 25],
  10: [23, 24, 25],
  11: [23, 24, 25],
};
export const filterSubConditionMaping = {
  2: { 28: [1, 2, 3, 4, 5], 29: [4, 5] },
};

export const nodeTypes = {
  1: "trigger",
  2: "waitForPeriod",
  3: "waitTillTime",
  4: "waitForTrigger",
  5: "ifElse",
  6: "split",
  7: "goTo",
  8: "sendMail",
  15: "removeFromList",
  10: "updateContact",
  12: "addTag",
  13: "removeTag",
  14: "addToList",
  9: "deleteContact",
};
